import type { ParsedQs } from "qs";
import { useCallback, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  convertStringUndefined,
  createSearchString,
  parseSearchString,
} from "../components/navigation/SearchString";

interface Result<T> {
  params: T;
  updateFilters: (values: T) => void;
  ready: boolean;
}

export default function useGetParsedSearchString<T>(
  convert?: (params: ParsedQs) => T,
): Result<T> {
  const location = useLocation();
  const navigate = useNavigate();

  const [state, setState] = useState<{ params: T; ready: boolean }>({
    ready: false,
    params: {} as T,
  });

  const setFiltersToRoute = useCallback(
    (values: T): void => {
      const stringValues = { ...values };
      const newSearchString = createSearchString(
        convertStringUndefined(stringValues),
      );
      if (
        location.search === ""
          ? newSearchString !== ""
          : `?${newSearchString}` !== location.search
      ) {
        console.log("update search", newSearchString);
        navigate({
          ...location,
          search: newSearchString,
        });
      }
    },
    [location, navigate],
  );

  useEffect(() => {
    const queryParams: ParsedQs = parseSearchString(location.search);
    const params = convert
      ? convert(queryParams)
      : (queryParams as unknown as T);

    setState({
      params: params,
      ready: true,
    });
    setFiltersToRoute(params);
  }, [location.search, setFiltersToRoute, convert]);

  return {
    ...state,
    updateFilters: setFiltersToRoute,
  };
}
